import PaymentInfoApproveStep from "./PaymentInfoApproveStep";

export default PaymentInfoApproveStep;
